<template>
	<div>
		<section id="hero_info">
			<article>
				<div class="main-wraper">
					<img v-if="false" src="/kr/resume/static/renew_img/hero_info.png">
				</div>
				<p class="caption">자주있는 질문</p>
			</article>
		</section>
		<section class="info-cream">
			<div class="content-wrapper">
				<article class="info">
					<h2 id="info00"><span>목차</span></h2>
					<ul class="disc">
						<li>yagish에 대하여<br>
							<a href="#info01">└ 서비스 이용금액은 얼마인가요?</a><br>
							<a href="#info02">└ 문서는 어떤 파일 형식을 지원하나요?</a><br>
							<a href="#info03">└ 작성 가능한 이력서 크기를 알려주세요.</a><br>
							<a href="#info04">└ 통신 환경이 나빠도 (또는 오프라인에서도) 이력서 작성이 가능합니까?</a><br>

						</li>
						<li>로그인<br>
							<a href="#info05">└ 로그인을 하지 않아도 사용 가능하나요?</a><br>
							<a href="#info06">└ 로그인은 어떻게 하나요?</a><br>
							<a href="#info07">└ 로그인이 안돼요.</a>
						</li>
						<li>입력데이터 관리<br>
							<a href="#info08">└ 핸드폰을 변경해도 이전 데이터를 사용 할 수 있나요?</a><br>
							<a href="#info09">└ 지원기업별로 이력서 내용을 저정해 둘 수 있나요?</a><br>
							<a href="#info10">└ 로그인을 안했는데 예전에 입력한 내용이 남아있어요.</a><br>
							<a href="#info11">└ 입력한 데이터가 사라져 버렸습니다.</a>
						</li>
						<li>다운로드<br>
							<a href="#info12">└ 다운로드가 안돼요.</a><br>
							<a href="#info13">└ 다시 다운로드 하는 방법을 모르겠어요.</a><br>
							<a href="#info14">└ 컬러와 흑백 인쇄의 차이점은 무엇인가요?</a><br>
							<a href="#info21">└ 학력·경력 안의 선 굵기가 다릅니다.</a>
						</li>
						<li>운영회사<br>
							<a href="#info16">└ 입력한 개인정보나 데이터는 어떤식으로 취급되나요?</a><br>
							<a href="#info17">└ 운영사는 어떤 회사인가요?</a>
						</li>
						<li>기타<br>
							<a href="#info18">└ 메일이 오지 않아요.</a><br>
							<a href="#info19">└ 질문이나 요청사항이 있으면 어디로 문의하면 되나요?</a><br>
							<a href="#info20">└ 탈퇴는 어떻게 하나요?</a>
						</li>

					</ul>
				</article>
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2><span>yagish에 대하여</span></h2>
				<ul class="step">
					<li>
						<p class="step-num" id="info01"><span>Q</span>서비스 이용금액은 얼마인가요？</p>
						<p class="plaintext">무료로 이용하실 수 있습니다.단 편의점 인쇄는 유료입니다.</p>
					</li>
					<li>
						<p class="step-num" id="info02"><span>Q</span>문서는 어떤 파일 형식을 지원하나요?？</p>
						<p class="plaintext">PDF로 출력 할 수 있습니다.</p>
					</li>
					<li>
						<p class="step-num" id="info03"><span>Q</span>작성 가능한 이력서 크기를 알려주세요.</p>
						<p class="plaintext">이력서의 크기는 A4, A3, B4입니다.<br>
							경력의 글자수와 항목 수에 따라 행과 레이아웃, 페이지수가 달라집니다.<br>
							※이력서의 종류나 내용에 관한 요청이나 의견이 있으시면
							<a href="https://docs.google.com/forms/d/e/1FAIpQLSdQWd8nDWMjACUan0rTQH7zQA7kP9tK_YoU5GL2_CpbUpUIiw/viewform"
								target="_blank">요청 양식</a>으로 전달해주시면 감사하겠습니다(향후 업데이트에 참고하겠습니다)
						</p>
					</li>
					<li>
						<p class="step-num" id="info04"><span>Q</span>통신환경이 나빠도 (또는 오프라인에서도) 이력서 작성이 가능합니까?</p>
						<p class="plaintext">yagish(야기슈)는 PWA(Progressive Web Apps)를 지원하며, 한 번 사이트를 열면 오프라인에서도 이용이
							가능합니다.지하철이나 통신환경이 나빠도 쾌적하게 입력할 수 있습니다.<br>
							<span class="red">※이력서 PDF 출력은 서버와의 통신이 필요하므로 온라인 환경에서 시도하십시오.</span>
						</p>
					</li>
				</ul>
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2><span>로그인</span></h2>
				<ul class="step">
					<li>
						<p class="step-num" id="info05"><span>Q</span>로그인을 하지 않아도 사용 가능하나요?？</p>
						<p class="plaintext">이력서 작성은 로그인 없이 이용하실 수 있습니다.<br>
							PDF 출력, 백업, 편의점 인쇄 등 더 많은 기능을 이용할 경우 로그인을 권장합니다.</p>
					</li>
					<li>
						<p class="step-num" id="info06"><span>Q</span>로그인은 어떻게 하나요？</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info03.png">
						<p class="plaintext">메뉴바 우측 상단의 「로그인」을 클릭하여 로그인페이지를 열러 주세요.</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info04.png">
						<p class="plaintext">[Google계정으로 로그인]으로 로그인이 가능합니다.<br>
							이메일 주소를 입력하고 [메일 링크 보내기] 클릭. 본인 이메일로 수신된 링크를 클릭하하여 로그인이 완료 해주세요.<br>
							데이터 저장 및 가져오기가 가능하며, 자신의 이메일로 이력서를 전송 할 수 있습니다.</p>
					</li>
					<li>
						<p class="step-num" id="info07"><span>Q</span>로그인이 안돼요.</p>
						<p class="plaintext">권장 환경에서의 이용을 부탁드립니다.</p>
						<p class="plaintext">iOS 단말기를 사용하시는 분은, 반드시 safari 브라우저로 접속해 주세요.<br>
							Google 로그인이 안되는 경우:<br>
							①iOS 단말기에서 크롬을 사용하는 경우 구글 로그인이 안 될 수 있으니 safari를 이용해 주세요.<br>
							②LINE이나 Gmail등에서 Yagish의 URL을 클릭해 접속할때 사용된 브라우저가 Safari가 아닌 경우가 있습니다.<br>
							<span class="red">그러므로 iOS 단말기를 사용하시는 분들은 반드시 safari 브라우저로 접속해 주시기 바랍니다.</span>
						</p>
						<ul class="disc">
							<li>
								안드로이드 스마트폰
								<p class="plaintext">OS: 8.0.0 이후,<span class="bold">권장 브라우저: GoogleChrome</span></p>
							</li>
							<li>
								iPhone
								<p class="plaintext">OS: 11.3 이후,<span class="bold">권장 브라우저: Safari</span></p>
							</li>
							<li>
								Windows
								<p class="plaintext">OS: Windows10, 권장 브라우저: GoogleChrome</p>
							</li>
							<li>
								Mac
								<p class="plaintext">OS: High Sierra, 권장 브라우저: GoogleChrome</p>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2><span>입력데이터 관리</span></h2>
				<ul class="step">
					<li>
						<p class="step-num" id="info08"><span>Q</span>핸드폰을 변경해도 이전 데이터를 사용 할 수 있나요?</p>
						<p class="plaintext">백업파일을 생성하면 어떤 휴대폰 기종에서든 로그인하여 백업 데이터를 가져올수 있습니다.</p>
					</li>
					<li>
						<p class="step-num" id="info09"><span>Q</span>지원기업별로 이력서 내용을 저정해 둘 수 있나요?</p>
						<img v-if="false" src="/kr/resume/static/renew_img/img_info02.png">
						<p class="plaintext">유지 할 수 있는 입력 내용은 템플릿을 불문하고 공통으로 되어 있기 때문에 중간에 이력서의 종류를 바꾸더라도 내용을 가져올수 있는 대신
							이력서마다 다른 내용을 저장할 수 없게 되어 있습니다.<br>
							만약 지원 기업별로 내용을 바꾸고 싶다면 [로그인/마이페이지 → 백업 생성] 에서 현시점의 내용을 수동으로 저장해 두면 필요할 때 그 내용을 복원할 수 있습니다.
						</p>
					</li>
					<li>
						<p class="step-num" id="info10"><span>Q</span>로그인을 안했는데 예전에 입력한 내용이 남아있어요.</p>
						<p class="plaintext">이용하시는 단말기의 브라우저(Safari나 Chrome 등) 기본 설정때문에 입력 내용이 저장될 수 있습니다.<br>
							이 이력은 해당 단말기를 사용하고 있는 본인만 볼 수 있습니다.<br>
							<span class="red">데이터를 남기고 싶지 않은 경우 [로그인/마이페이지] → 화면 아래 [설정] → [데이터·계정의 삭제] 에서 삭제할 수
								있습니다.</span>
						</p>
						<div class="delite">
							<a href="https://rirekisho.yagish.jp/account/delete" class="btn_green">데이터 계정 삭제</a>
						</div>

					</li>
					<li>
						<p class="step-num" id="info11"><span>Q</span>입력한 데이터가 사라져 버렸습니다.</p>
						<p class="plaintext">브라우저의 이력 삭제나 단말기의 기종 변경등으로 브라우저에 보존된 yagish(야기슈)의 데이터는 삭제 됩니다.<br>
							데이터 삭제를 원치 않으신분은 서버 백업이나 PDF를 메일 보내기 기능을 사용 해주세요.<br>
							덧붙여 yagish의 염소가 이력서를 먹은 사건은 현재로서는 확인할 수 없습니다.<br>
							인쇄한 이력서에는 잉크, 토너 등 염소의 건강에 나쁜 성분이 포함되어 있으므로 만약 그러한 염소를 발견할 경우 건강을 위해 먹지 못하게 해주세요.
						</p>
					</li>
				</ul>
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2><span>다운로드</span></h2>
				<ul class="step">
					<li>
						<p class="step-num" id="info12"><span>Q</span>다운로드가 안돼요.</p>
						<p class="plaintext">고객님의 통신 상태에 따라 다운로드의 완료시간이 다릅니다.다운로드 버튼 누르시고 잠시만 기다려주세요.<br>
							또한 일정 시간 경과하면 다운로드 오류가 발생하므로 통신 환경을 확인하여 시도해 보시기 바랍니다.
						</p>
					</li>
					<li>
						<p class="step-num" id="info13"><span>Q</span>다시 다운로드 하는 방법을 모르겠어요.</p>
						<p class="plaintext">다운로드를 실행하면 버튼의 색상이 반전되어 버튼을 누를 수 없게 됩니다.<br>
							아래의 방법 중 하나로 다시 다운로드 할 수 있습니다.<br>
							<span class="red">・메인화면으로 돌아간다.</span><br>
							<span class="red">・이력서 수정을 한다.</span><br>
							<span class="red">・페이지를 다시 불러온다.(새로고침)</span>
						</p>
					</li>
					<li>
						<p class="step-num" id="info14"><span>Q</span>컬러와 흑백 인쇄의 차이점은 무엇인가요?</p>
						<p class="plaintext">컬러 인쇄는 첨부한 증명사진도 인쇄됩니다.<br>
							흑백 인쇄는 첨부한 증명 사진은 인쇄되지 않습니다.<br>증명사진을 별도로 붙여주세요.
						</p>
					</li>
					<li>
						<p class="step-num" id="info21"><span>Q</span>학력·경력 내의 선 굵기가 다릅니다</p>
						<p class="plaintext">Mac 사용시 크롬에서 다운로드한 이력서 PDF 파일을 열면 학력/경력 등 일부 선이 굵어질 수 있습니다.<br>
							대신, Finder에서 PDF 파일을 열어 주시면 정상적인 굵기로 되어 있으므로 안심하시기 바랍니다.<br>
							또, Yagish 인쇄도 정상적으로 출력 되어집니다.
						</p>
					</li>
				</ul>
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2><span>운영회사</span></h2>
				<ul class="step">
					<li>
						<p class="step-num" id="info16"><span>Q</span>입력한 개인정보나 데이터는 어떤 식으로 취급되나요?</p>
						<p class="plaintext">로그인을 하지 않은 경우 데이터 입력 및 PDF 출력 모두 서버에 저장되지 않습니다(고객님의 기기 브라우저에만 남습니다).<br>
							로그인 한 경우 백업 등의 데이터가 yagish(야기슈) 서버에서 저장됩니다.<br>
							이름이나 주소 등 개인정보는 외부에 제공되지 않습니다.<br>
							Google시큐리티를 사용하고 있기 때문에 안전합니다.<br>
							보다 나은 서비스를 제공하기 위해 개인정보는 암호화하여 외부 서비스와 연계하며 새로운 기능 개발시 암호화 데이터를 참조하는 경우가 있습니다.
						</p>
					</li>
					<li>
						<p class="step-num" id="info17"><span>Q</span>운영사는 어떤 회사인가요?</p>
						<p class="plaintext">yagish(야기슈)는 주식회사 Yagish가 운영하는 서비스입니다.</p>
					</li>
				</ul>
			</div>
		</section>
		<section class="info-white">
			<div class="content-wrapper">
				<h2><span>기타</span></h2>
				<ul class="step">
					<li>
						<p class="step-num" id="info18"><span>Q</span>메일이 오지 않아요.</p>
						<p class="plaintext">무료메일이나 기업 메일서비스에서는 고객이 스팸 메일 설정을 하지 않아도 자동으로 스팸 메일로 분류되는 경우가 있습니다.<br>
							스팸 메일 폴더나 스팸 메일 설정을 확인해 주세요.
						</p>
					</li>
					<li>
						<p class="step-num" id="info19"><span>Q</span>질문이나 요청사항이 있으면 어디로 문의하면 되나요?</p>
						<p class="plaintext">문의 및 요청 사항은 <a
								href="https://docs.google.com/forms/d/e/1FAIpQLSdQWd8nDWMjACUan0rTQH7zQA7kP9tK_YoU5GL2_CpbUpUIiw/viewform"
								target="_blank">여기로</a>연락주세요.</p>
					</li>
					<li>
						<p class="step-num" id="info20"><span>Q</span>탈퇴는 어떻게 하나요?</p>
						<p class="plaintext">탈퇴를 원하실 경우 [로그인/마이페이지] → [데이터 계정 삭제] 에서 탈퇴(계정 삭제)할 수 있습니다.<br>
							<span class="red">또한 계정 삭제 전에 「서버 백업 삭제」를 해주시기 바랍니다.</span>
						</p>
						<div class="delite">
							<a href="/kr/resume/account/delete" class="btn_green">데이터/계정 삭제</a>
						</div>
					</li>
				</ul>
			</div>
		</section>
	</div>
</template>
<style lang="css" src="@/assets/css/renew_info.css"></style>
<script>
export default {
	data: function () {
		return {}
	},
	computed: {},
	methods: {},
	watch: {},
	mounted: function () { }
}
</script>
